import React from "react";
import { Button } from "@vitalsource/vstui";
import styled from "styled-components";
import { t } from "../../core/translate";
import { connect } from "react-redux";
import { actions as libraryActions } from "../../../redux/ui/library";
import PropTypes from "prop-types";

const OffScreenButton = styled(Button)`
  &.panel-close-button {
    clip: rect(0px, 0px, 0px, 0px);
    filter: alpha(opacity=0);
    height: 1px;
    margin: 0;
    opacity: 0;
    overflow: hidden;
    padding: 0;
    position: absolute;
    outline: 0;
    right: 5px;
    top: 10px;
    span {
      box-shadow: 0 6px 18px rgba(0, 0, 0, 0.1);
      font-size: 1.2rem;
      outline: 1px dotted #333333;
      text-decoration: underline;
      z-index: 9999;
      height: 30px;
      padding: 5px;
      line-height: 2.5;
      top: 12px;
      right: 0%;
    }
    &:focus {
      clip: auto;
      filter: alpha(opacity=100);
      opacity: 1;
      overflow: visible;
      &:-moz-focusring {
        overflow: visible;
      }
    }
  }
`;

class ScreenReaderCloseButton extends React.Component {
  render() {
    const { label, clickEvent, closePanel } = this.props;

    return (
      <OffScreenButton
        className={"panel-close-button noButton naked"}
        onClick={clickEvent || closePanel}
      >
        <span>{label || t("base.close-panel")}</span>
      </OffScreenButton>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  closePanel: () => dispatch(libraryActions.closePanel())
});

ScreenReaderCloseButton.propTypes = {
  label: PropTypes.string,
  clickEvent: PropTypes.func
};

export default connect(
  null,
  mapDispatchToProps
)(ScreenReaderCloseButton);
